<template>
  <div class="RegisterCardStyle">
    <UserBase :title="title" :isShowToLogin="isShowToLogin">
      <template #default>
        <v-row no-gutters class="pb-2" justify="center" align-content="center">
          <v-col cols="10" class="text-center">
            <slot />
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import UserBase from '@/components/layouts/UserBase/UserBase'

export default {
  components: {
    UserBase
  },
  props: {
    title: { default: 'メールを送信しました' },
    isShowToLogin: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      //
    }
  },
  methods: {}
}
</script>
